export enum ETemplateType {
  DEFAULT = 'DEFAULT',
  AUTHENTIQUE = 'AUTHENTIQUE',
  KB = 'KB',
  EBAY = 'EBAY',
  EBAY_OPERATOR = 'EBAY_OPERATOR',
}
